export class KDSUser {
    id: number;
    email: string;
    password: string;
    user_type_id: number;
    user_created_id: number;        
}